import React from "react";
import "./index.css";

// ScrollAnimation component (reused from previous components)
class ScrollAnimation extends React.Component {
  state = {
    isVisible: false,
  };

  domRef = React.createRef();

  componentDidMount() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.setState({ isVisible: true });
        observer.unobserve(this.domRef.current);
      }
    });

    observer.observe(this.domRef.current);
  }

  render() {
    const { children, stagger } = this.props;
    const staggerClass = stagger ? `stagger-${stagger}` : "";

    return (
      <div
        className={`gallery-scroll-animation ${
          this.state.isVisible ? "is-visible" : ""
        } ${staggerClass}`}
        ref={this.domRef}
      >
        {children}
      </div>
    );
  }
}

class Gallery extends React.Component {
  // State initialization without constructor
  state = {
    selectedImage: null,
    activeCategory: null,
  };

  // Create ref without constructor
  containerRef = React.createRef();

  // Gallery items data
  galleryItems = [
    {
      id: 1,
      title: "Youngstown Event Center",
      subtitle: "Wedding Reception",
      image:
        "https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "events",
    },
    {
      id: 2,
      title: "Youngstown Event Center",
      subtitle: "Corporate Conference",
      image:
        "https://images.unsplash.com/photo-1472162072942-cd5147eb3902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "events",
    },
    {
      id: 3,
      title: "Crawling to Destiny",
      subtitle: "Children's Activities",
      image:
        "https://images.unsplash.com/photo-1587393855524-087f83d95bc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "education",
    },
    {
      id: 4,
      title: "New Vision Behavioral Health",
      subtitle: "Therapy Session",
      image:
        "https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "health",
    },
    {
      id: 5,
      title: "Hitchcock Woods Learning",
      subtitle: "Classroom Activities",
      image:
        "https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "education",
    },
    {
      id: 6,
      title: "W.L.W. Enterprise",
      subtitle: "Business Consultation",
      image:
        "https://images.unsplash.com/photo-1531498860502-7c67cf02f657?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "business",
    },
    {
      id: 7,
      title: "W.L.W. Enterprise",
      subtitle: "Marketing Strategy",
      image:
        "https://images.unsplash.com/photo-1551818255-e6e10975bc17?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "business",
    },
    {
      id: 8,
      title: "Youngstown Event Center",
      subtitle: "Event Planning",
      image:
        "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      category: "events",
    },
  ];

  // Filter categories
  categories = [
    { id: "all", name: "All" },
    { id: "events", name: "Events" },
    { id: "business", name: "Business" },
    { id: "education", name: "Education" },
    { id: "health", name: "Health" },
  ];

  openLightbox = (item) => {
    this.setState({ selectedImage: item });
  };

  closeLightbox = () => {
    this.setState({ selectedImage: null });
  };

  handleCategoryChange = (categoryId) => {
    this.setState({ activeCategory: categoryId === "all" ? null : categoryId });
  };

  // Navigation functions for lightbox
  navigateGallery = (direction) => {
    const { selectedImage, activeCategory } = this.state;
    if (!selectedImage) return;

    // Get filtered items based on active category
    const filteredItems = activeCategory
      ? this.galleryItems.filter((item) => item.category === activeCategory)
      : this.galleryItems;

    const currentIndex = filteredItems.findIndex(
      (item) => item.id === selectedImage.id
    );
    let newIndex;

    if (direction === "next") {
      newIndex = (currentIndex + 1) % filteredItems.length;
    } else {
      newIndex =
        (currentIndex - 1 + filteredItems.length) % filteredItems.length;
    }

    this.setState({ selectedImage: filteredItems[newIndex] });
  };

  render() {
    const { selectedImage, activeCategory } = this.state;

    // Filter items based on active category
    const filteredItems = activeCategory
      ? this.galleryItems.filter((item) => item.category === activeCategory)
      : this.galleryItems;

    return (
      <section id="gallery" className="gallery-section">
        {/* Decorative background elements */}
        <div className="gallery-bg-decoration gallery-bg-decoration-top"></div>
        <div className="gallery-bg-decoration gallery-bg-decoration-bottom"></div>

        <div className="gallery-container">
          <ScrollAnimation>
            <div className="gallery-header">
              <span className="gallery-tag">Our Portfolio</span>
              <h2 className="gallery-title">
                Success{" "}
                <span className="gallery-title-highlight">
                  Gallery
                  <span className="gallery-title-underline"></span>
                </span>
              </h2>
              <p className="gallery-subtitle">
                Explore our portfolio showcasing the success stories and
                achievements across our diverse business ventures.
              </p>

              {/* Filter Categories */}
              <div className="gallery-filters">
                {this.categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() =>
                      this.handleCategoryChange(
                        category.id === "all" ? null : category.id
                      )
                    }
                    className={`gallery-filter-button ${
                      (category.id === "all" && !activeCategory) ||
                      activeCategory === category.id
                        ? "gallery-filter-active"
                        : ""
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </ScrollAnimation>

          <div className="gallery-grid" ref={this.containerRef}>
            {filteredItems.map((item, index) => (
              <ScrollAnimation key={item.id} stagger={(index % 4) + 1}>
                <div
                  className="gallery-card"
                  onClick={() => this.openLightbox(item)}
                >
                  {/* Category badge */}
                  <div className="gallery-card-badge">
                    <span className="gallery-card-category">
                      {item.category
                        ? item.category.charAt(0).toUpperCase() +
                          item.category.slice(1)
                        : ""}
                    </span>
                  </div>

                  {/* Image */}
                  <div className="gallery-card-image-container">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="gallery-card-image"
                    />
                  </div>

                  {/* Overlay with content */}
                  <div className="gallery-card-overlay">
                    <h3 className="gallery-card-title">{item.title}</h3>
                    <p className="gallery-card-subtitle">{item.subtitle}</p>

                    <div className="gallery-card-view-button">
                      <svg
                        className="gallery-card-view-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </ScrollAnimation>
            ))}
          </div>

          {filteredItems.length === 0 && (
            <div className="gallery-empty-message">
              <p>No items found in this category.</p>
            </div>
          )}

          {/* Lightbox */}
          {selectedImage && (
            <div className="gallery-lightbox" onClick={this.closeLightbox}>
              <div
                className="gallery-lightbox-content"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close button */}
                <button
                  className="gallery-lightbox-close"
                  onClick={this.closeLightbox}
                >
                  <svg
                    className="gallery-lightbox-close-icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                {/* Navigation buttons */}
                <button
                  className="gallery-lightbox-nav gallery-lightbox-prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.navigateGallery("prev");
                  }}
                >
                  <svg
                    className="gallery-lightbox-nav-icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </button>

                <button
                  className="gallery-lightbox-nav gallery-lightbox-next"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.navigateGallery("next");
                  }}
                >
                  <svg
                    className="gallery-lightbox-nav-icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>

                {/* Image */}
                <div className="gallery-lightbox-image-container">
                  <img
                    src={selectedImage.image}
                    alt={selectedImage.title}
                    className="gallery-lightbox-image"
                  />
                </div>

                {/* Caption */}
                <div className="gallery-lightbox-caption">
                  <div className="gallery-lightbox-caption-content">
                    <div className="gallery-lightbox-details">
                      <h3 className="gallery-lightbox-title">
                        {selectedImage.title}
                      </h3>
                      <p className="gallery-lightbox-subtitle">
                        {selectedImage.subtitle}
                      </p>
                    </div>
                    <div className="gallery-lightbox-category">
                      {selectedImage.category
                        ? selectedImage.category.charAt(0).toUpperCase() +
                          selectedImage.category.slice(1)
                        : "General"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default Gallery;
